export default __webpack_public_path__ + "static/media/oncology5.03403c39.jpg";